import React from "react";
import { Grid, Typography } from "@mui/material";

interface MessageCardProps {
  heading?: string;
  heading2?: string;
  subheading?: string;
  content?: string;
  headingTestId?: string;
  heading2TestId?: string;
  subheadingTestId?: string;
  contentTestId?: string;
}

export const MessageCard = (props: MessageCardProps) => {
  return (
    <>
      <Grid container direction={"row"} spacing={2} justifyContent={"space-between"}>
        <Grid item>
          <Typography data-testid={props.headingTestId} variant={"h6"}>
            {props.heading}
          </Typography>
        </Grid>
        <Grid item>
          <Typography data-testid={props.heading2TestId}>{props.heading2}</Typography>
        </Grid>
      </Grid>
      <Grid item style={{ paddingBottom: 14 }}>
        <Typography data-testid={props.subheadingTestId}>{props.subheading}</Typography>
      </Grid>
      <Grid item>
        <Typography data-testid={props.contentTestId}>{props.content}</Typography>
      </Grid>
    </>
  );
};
